export default __webpack_public_path__ + "static/media/Akhlak Hossain Jim Projects Amazon clone 960.86a2693d.webp";